import Toast from 'muse-ui-toast'

export function isPhone (phone) {
  return /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/.test(phone)
}

export function isIOS () {
  // 兼容最新版的ipad pro
  return navigator.userAgent.match(/iphone|ipad|ipod/i) || (/macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
}

export function isWeixin () {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
}

export function isMobile () {
  return !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/)
}

export function isQQ () {
  return (isIOS() && /\sqq/i.test(navigator.userAgent.toLowerCase())) || (!isIOS() && /MQQBrowser/i.test(navigator.userAgent) && /QQ/i.test((navigator.userAgent).split('MQQBrowser')))
}

export function validate (list) {
  let status = list.every((item) => {
    if (!item.options) {
      if (!item.val) {
        Toast.error(item.msg)
        return false
      }
    }
    if (item.options && typeof item.options === 'object' && item.options.id === 885) {
      if (!item.val) {
        Toast.error('请输入微信验证码')
        return false
      }
    }
    if (item.options === 'phone') {
      if (!item.val) {
        Toast.error('手机号不能为空')
        return false
      }
      if (!isPhone(item.val)) {
        Toast.error('请输入正确的手机号')
        return false
      }
    }
    if (item.options === 'same') {
      if (item.val[0] !== item.val[1]) {
        Toast.error('两次密码不一致')
        return false
      }
    }
    if (item.options === 'noSame') {
      if (item.val[0] === item.val[1]) {
        Toast.error('新旧密码不能一样')
        return false
      }
    }
    if (item.options === 'feCode' && item.id === 885) {
      if (item.val[0].toLowerCase() !== item.val[1].toLowerCase()) {
        Toast.error('请输入正确的验证码')
        return false
      }
    }
    return true
  })
  return status
}

// iPhone X、iPhone XS
const isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812
// iPhone XS Max
const isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896
// iPhone XR
const isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896

export function isIOSBangs () {
  if (isIOS && (isIPhoneX || isIPhoneXSMax || isIPhoneXR)) {
    return true
  } else {
    return false
  }
}
